import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';

export class NgSecureContext {
    public permissions: Array<number> = [];
}

@Directive({ selector: '[secured]' })
export class SecuredDirective {

    private hasView = false;
    private context: NgSecureContext = new NgSecureContext();

    constructor(
        private authService: AuthenticationService,
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<NgSecureContext>) {
    }

    @Input('secured')
    set _permissions(permission: number | Array<number>) {
        if (typeof permission === 'string') {
            this.context.permissions = [permission] as Array<number>;
        } else if (permission instanceof Array) {
            this.context.permissions = permission as Array<number>;
        }

        this._updateView();
    }

    private _updateView() {
        let isAuthenticated = true;

        if (this.authService.isAuthenticated) {
            isAuthenticated = this.authService.hasPermission(this.context.permissions);
        }

        if (isAuthenticated && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef, this.context);
            this.hasView = true;
        } else if (!isAuthenticated && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }

    }
}
